/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
    name: 'CreatePageModal',

    props: {
        onConfirm: {
            type: Function,
            required: true
        },

        event: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            nameControl: {
                name: 'name',
                kind: 'text',
                no_label: true,
                hint: this.$t('general.forms.content_page.name_hint'),
                hintAfterLabel: true,
                order: 1
            },
            name: null
        };
    },

    methods: {
        closeModal() {
            this.$emit('close');
        },


        async save() {
            if (await this.$refs.form.validate()) {
                this.createPage();
            }
        },

        createPage() {
            this.onConfirm({
                name: this.name
            });

            this.closeModal();
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "create-page-modal modal-wrapper" }, [
    _c("div", { staticClass: "modal-header" }, [
      _c(
        "a",
        {
          staticClass: "close",
          attrs: { href: "#", "aria-label": _vm.$t("general.close") },
          on: { click: _vm.closeModal },
        },
        [_vm._v("×")]
      ),
      _c("h3", [
        _vm._v(_vm._s(_vm.$t("general.forms.content_page.create_page"))),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _c(
          "validation-observer",
          {
            ref: "form",
            staticClass: "meta-form",
            attrs: { tag: "form" },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.save()
              },
            },
          },
          [
            _c("validation-provider", {
              attrs: {
                rules: "required",
                slim: "slim",
                name: _vm.$t("general.forms.content_page.name"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var errors = ref.errors
                    return [
                      _c("meta-control", {
                        attrs: {
                          control: _vm.nameControl,
                          errors: errors,
                          name: "page_name",
                        },
                        model: {
                          value: _vm.name,
                          callback: function ($$v) {
                            _vm.name = $$v
                          },
                          expression: "name",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn",
          attrs: { type: "button" },
          on: { click: _vm.closeModal },
        },
        [_vm._v(_vm._s(_vm.$t("general.cancel")))]
      ),
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { type: "button" },
          on: { click: _vm.save },
        },
        [_vm._v(_vm._s(_vm.$t("general.create")))]
      ),
    ]),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/modals/CreatePageModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__